export default "__VITE_ASSET__Cui92f9I__";